'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { Big } from 'foundations-components/transitional/components/Big';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import * as DefaultFilterNames from 'SalesContentIndexUI/data/lib/DefaultFilterNames';
import { Section } from 'foundations-components/transitional/components/Section';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const getTitleText = (selectedViewFilter, contentType) => {
  let emptyStateType = 'createdByMe';
  if (selectedViewFilter.id === DefaultFilterNames.CREATED_BY_MY_TEAM || selectedViewFilter.id === DefaultFilterNames.OWNED_BY_MY_TEAM) {
    emptyStateType = 'createdByMyTeam';
  } else if (selectedViewFilter.type === DefaultFilterNames.TEAM) {
    emptyStateType = 'createdByAnotherTeam';
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: `salesContentIndexUI.emptyState.filter.${contentType}.titleText.${emptyStateType}`
  });
};
const NoSearchResults = ({
  contentType,
  selectedViewFilter
}) => {
  const primaryContent = /*#__PURE__*/_jsx(Big, {
    tagName: "p",
    use: "help",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `salesContentIndexUI.emptyState.filter.${contentType}.subText`
    })
  });
  const emptyState = /*#__PURE__*/_jsx(EmptyState, {
    flush: true,
    primaryContent: primaryContent,
    secondaryContent: /*#__PURE__*/_jsx(Illustration, {
      name: "empty-state-charts",
      width: 200
    }),
    secondaryContentWidth: 200,
    titleText: getTitleText(selectedViewFilter, contentType)
  });
  return /*#__PURE__*/_jsx(Section, {
    marginBlock: 1000,
    "data-selenium-test": "EmptyStateMessage",
    children: /*#__PURE__*/_jsx(View, {
      marginInline: "auto",
      as: "div",
      children: emptyState
    })
  });
};
export default NoSearchResults;